module.exports = __webpack_public_path__ + "media/src/images/icon__twitter-48c50e6a7c044fd17b5d9300a858baea.png";